import { render, staticRenderFns } from "./other_organization_members.vue?vue&type=template&id=023a4c87&scoped=true&"
import script from "./other_organization_members.vue?vue&type=script&lang=js&"
export * from "./other_organization_members.vue?vue&type=script&lang=js&"
import style0 from "./other_organization_members.vue?vue&type=style&index=0&id=023a4c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a4c87",
  null
  
)

export default component.exports